module.exports = __webpack_public_path__ + "img/Nimes.38cb688d.png";